import "./index.scss";

import IsOnline from "assets/img/svg/isOnline";
import { useTranslation } from "react-i18next";
import { PeriodActiveStatus } from "store/types";

/**
 * This component render a status chip coloured for statements
 */
interface IStatementStatusChip {
    /**
     * Status of the statement
     */
    status: number;
}

const StatementStatusChip = ({ status }: IStatementStatusChip) => {
    const [t] = useTranslation();

    const statusData = {
        [PeriodActiveStatus.CLOSED]: { label: "closed", color: "#267847", text: t("BPStatement.DefinitiveStatement") },
        [PeriodActiveStatus.OPENED]: { label: "opened", color: "#848B4F", text: t("BPStatement.TemporaryStatement") },
        [PeriodActiveStatus.PENDING]: { label: "pending", color: "#9185CB", text: t("BPStatement.PendingStatement") },
    };
    if (status === undefined) return;

    return (
        <div className={`statement-status-chip ${statusData[status]?.label}`}>
            <IsOnline fill={statusData[status].color} />
            {statusData[status].text}
        </div>
    );
};

export default StatementStatusChip;
